import React from 'react';  // import the React library
import { FacebookIcon, FacebookShareButton, LinkedinShareButton, TwitterShareButton, TwitterIcon, LinkedinIcon } from 'react-share';
 
function SocialMedia(props) {
    return (
        <>
        <FacebookShareButton url={props.url}  quote={props.title} hashtag={props.hashtag}>
            <FacebookIcon round={true} size={48}/>
          </FacebookShareButton>

          <TwitterShareButton url={props.url} title={props.title}  hashtags={props.hashtagArray}  via={props.via}>
            <TwitterIcon round={true} size={48} />
          </TwitterShareButton>

          <LinkedinShareButton url={props.url} title={props.title}  hashtags={props.hashtagArray}  via={props.via}>
            <LinkedinIcon round={true} size={48} />
          </LinkedinShareButton>

        </>
        );
    }
  
  export default SocialMedia;
  
